import React from 'react'
import { Intent } from '@blueprintjs/core'
import { browserHistory } from 'browser/history'
import { Entity } from 'shared-libs/models/entity'
import { CacUtils } from 'shared-libs/helpers/cacUtils'
import { Button } from 'browser/components/atomic-elements/atoms/button/button'

import './_cac-resume-checkin-button.scss'

/**
 * @uiComponent
 *
 * Mobile-web equivalent of CacResumeCheckInButton. Reads the check-in entityId
 * from the CAC entity's denormalized appointment properties and navigates to
 * the check-in execution.
 */
interface ICacResumeCheckInButtonProps {
  entity?: Entity
  frames?: any
  buttonText?: string
}

export class CacResumeCheckInButton extends React.PureComponent<ICacResumeCheckInButtonProps> {
  static defaultProps = {
    buttonText: 'Resume Check-In',
  }

  public render() {
    return (
      <div className="cac-resume-checkin-button">
        <Button
          className="cac-resume-checkin-button__btn"
          intent={Intent.PRIMARY}
          buttonText={this.props.buttonText}
          onClick={this.handleClick}
        />
      </div>
    )
  }

  private handleClick = () => {
    const { frames } = this.props
    const entity = this.props.entity ?? frames?.getValue('entity')
    if (!entity) {
      return
    }

    const checkInEntityId = CacUtils.extractCheckInEntityIdForResume(entity)
    if (!checkInEntityId) {
      return
    }

    browserHistory.push(`/entity/${checkInEntityId}`)
  }
}
